/**
 * @fileoverview The backend's config could not be read (`GET /config`,
 * `lib/backendFeatures.ts`). A leaf module with no imports: `lib/apiErrors.ts`
 * lists the class among the request plumbing's own errors and is itself loaded
 * by server components, so the class must not drag the hook module (React) or
 * the Sentry client in behind it.
 *
 * Operator copy: no surface renders the message — the hook answers the unknown
 * state — and the status rides on the instance, where Sentry reads it, never in
 * the message.
 */

export class BackendConfigError extends Error {
  readonly status: number

  constructor(status: number) {
    super('Backend config could not be read')
    this.name = 'BackendConfigError'
    this.status = status
  }
}
